class FreezerService {
  constructor({ axios }) {
    this.axios = axios;
    this.url = '/api/biobank/freezers';
  }

  async getList({ query = '', dates = [] } = {}) {
    const result = await this.axios.get(this.url, {
      params: {
        query,
        ...(Object.keys(dates).length > 0 && dates),
      },
    });
    const { data } = result;
    return data;
  }

  async getOne({ id }) {
    const { data } = await this.axios.get(`${this.url}/${id}`);
    return data;
  }

  async create({ freezer }) {
    const { data } = await this.axios.post(this.url, freezer);
    return data;
  }

  async update({ freezer }) {
    const { data } = await this.axios.put(this.url, freezer);
    return data;
  }

  async archive({ freezer }) {
    const { _id: id } = freezer;
    const { data } = await this.axios.delete(`${this.url}/archive/${id}`, { data: freezer });
    return data;
  }
}

export default FreezerService;
